import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseRestApiService } from 'src/app/service/baseRestApiService.service';
import { EndPoints, UrlProviderService } from 'src/app/service/urlprovider.service';

@Injectable({
    providedIn: 'root'
})
export class ContactMechanismsService extends BaseRestApiService {
    constructor(http: HttpClient, urlProvider: UrlProviderService) {
        super(http, urlProvider);
    }

    indexContactMechanismTypes() {
        return this.get(EndPoints.contactMechanisms_indexContactMechanismTypes, undefined, undefined, undefined);
    }

    indexContactMechanismPurposeTypes() {
        return this.get(EndPoints.contactMechanisms_indexContactMechanismPurposeTypes, undefined, undefined, undefined);
    }

    indexGeographicalRegions() {
        return this.get(EndPoints.contactMechanisms_indexGeographicalRegions, undefined, undefined, undefined);
    }
}
